import type { PlacedBlock } from '@pieskowo/shared';

export function serializeLayout(blocks: PlacedBlock[]): string {
  return JSON.stringify(blocks);
}

export function deserializeLayout(raw: string): PlacedBlock[] {
  try {
    const v = JSON.parse(raw) as unknown;
    if (!Array.isArray(v)) return [];
    return v as PlacedBlock[];
  } catch {
    return [];
  }
}
